import { create } from 'zustand';
import { ImageCatalogEntry } from '@/types';
import { MOCK_IMAGES } from '@/data/mockData';

interface ImageCatalogStore {
  images: ImageCatalogEntry[];
  isLoading: boolean;
  error: string | null;

  // Actions
  fetchImages: (poolId?: string) => Promise<void>;
  getImageById: (imageId: string) => ImageCatalogEntry | undefined;
  getImagesByPool: (poolId: string, poolImageIds: string[]) => ImageCatalogEntry[];
}

export const useImageCatalogStore = create<ImageCatalogStore>((_set, get) => ({
  // Mock data — will be replaced when PoolManagement service is available
  images: MOCK_IMAGES,
  isLoading: false,
  error: null,

  fetchImages: async (_poolId?: string) => {
    // No-op: images are provided from mock data
  },

  getImageById: (imageId: string) => {
    return get().images.find(img => img.imageId === imageId);
  },

  getImagesByPool: (_poolId: string, poolImageIds: string[]) => {
    return get().images.filter(img => poolImageIds.includes(img.imageId));
  },
}));
